import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./containers/Main/App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";

import { SnackbarProvider } from "notistack";
import "./i18n";

import { gtmId, hotjarId } from "./utils/config";
import TagManager from "react-gtm-module";
import { hotjar } from "react-hotjar";

const tagManagerArgs = {
    gtmId: gtmId,
};


hotjar.initialize(hotjarId, 6);
TagManager.initialize(tagManagerArgs);


ReactDOM.render(
    <Suspense fallback={<div>Loading... </div>}>
        <React.StrictMode>
            <BrowserRouter>
                <SnackbarProvider maxSnack={5}>
                    <App />
                </SnackbarProvider>
            </BrowserRouter>
        </React.StrictMode>
    </Suspense>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// Boss UI geliştirme log1.1
serviceWorker.register();
